import { createContext, useContext } from 'react';

import { type LocalSessionAddressContextState } from '../types';

const LocalSessionContext =
  createContext<Nullable<LocalSessionAddressContextState>>(null);

const useLocalSessionAddressContext = () => {
  const context = useContext(LocalSessionContext);
  if (!context) {
    throw new Error(
      'useLocalSessionAddressContext must be used within a LocalSessionAddressProvider'
    );
  }
  return context;
};

export { LocalSessionContext, useLocalSessionAddressContext };
